'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _immutable = require('immutable');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SenderTypePropType = require('../../prop-types/SenderTypePropType');

var _SenderTypePropType2 = _interopRequireDefault(_SenderTypePropType);

var _senderTypes = require('conversations-schema/pubnub-message/constants/senderTypes');

var _commonMessageFormatGetters = require('conversations-schema/common-message-format/operators/commonMessageFormatGetters');

var _ChatHeadingConfigPropType = require('../../chat-heading-config/prop-types/ChatHeadingConfigPropType');

var _ChatHeadingConfigPropType2 = _interopRequireDefault(_ChatHeadingConfigPropType);

var _threadHistoryToMessageList = require('conversations-schema/thread-history/operators/threadHistoryToMessageList');

var _VisitorThreadHistoryItem = require('./VisitorThreadHistoryItem');

var _VisitorThreadHistoryItem2 = _interopRequireDefault(_VisitorThreadHistoryItem);

var _RecordPropType = require('conversations-prop-types/prop-types/RecordPropType');

var _RecordPropType2 = _interopRequireDefault(_RecordPropType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  attachments: _react.PropTypes.instanceOf(_immutable.Map),
  channel: _react.PropTypes.string,
  chatHeadingConfig: _ChatHeadingConfigPropType2.default.isRequired,
  coloring: (0, _RecordPropType2.default)('ColoringRecord'),
  companyName: _react.PropTypes.string,
  consentToCommunicateMessage: _react.PropTypes.string,
  currentRole: _SenderTypePropType2.default.isRequired,
  currentVisitor: (0, _RecordPropType2.default)('Visitor'),
  hasVisitorEmail: _react.PropTypes.bool.isRequired,
  onAttachmentClick: _react.PropTypes.func.isRequired,
  onAttachmentLoad: _react.PropTypes.func.isRequired,
  potentialResponders: _react.PropTypes.instanceOf(_immutable.List),
  predicate: _react.PropTypes.func.isRequired,
  publishMessage: _react.PropTypes.func,
  republishMessage: _react.PropTypes.func,
  requiresConsentToCommunicate: _react.PropTypes.bool,
  requiresExplicitConsentToProcess: _react.PropTypes.bool,
  responders: _react.PropTypes.instanceOf(_immutable.Map),
  sendFromResponders: _react.PropTypes.instanceOf(_immutable.List),
  sendVisitorEmailAddress: _react.PropTypes.func.isRequired,
  systemOnline: _react.PropTypes.bool.isRequired,
  threadHistory: (0, _RecordPropType2.default)('ThreadHistory').isRequired,
  typingResponder: (0, _RecordPropType2.default)('Responder')
};

var defaultProps = {
  attachments: (0, _immutable.Map)(),
  currentRole: _senderTypes.AGENT,
  onAttachmentClick: function onAttachmentClick() {},
  predicate: function predicate() {
    return true;
  }
};

var VisitorThreadHistory = function (_React$PureComponent) {
  _inherits(VisitorThreadHistory, _React$PureComponent);

  function VisitorThreadHistory() {
    _classCallCheck(this, VisitorThreadHistory);

    return _possibleConstructorReturn(this, (VisitorThreadHistory.__proto__ || Object.getPrototypeOf(VisitorThreadHistory)).apply(this, arguments));
  }

  _createClass(VisitorThreadHistory, [{
    key: 'renderHistory',
    value: function renderHistory() {
      var _this2 = this;

      var _props = this.props,
          threadHistory = _props.threadHistory,
          predicate = _props.predicate;


      var messages = (0, _threadHistoryToMessageList.threadHistoryToMessageList)(threadHistory).filter(predicate);

      return messages.map(function (message, index) {
        var previousMessage = index > 0 ? messages.get(index - 1) : undefined;
        var nextMessage = messages.get(index + 1);

        var key = [(0, _commonMessageFormatGetters.getSenderType)(message), (0, _commonMessageFormatGetters.getSenderId)(message), (0, _commonMessageFormatGetters.getClientTs)(message)].join('-');

        return _react2.default.createElement(_VisitorThreadHistoryItem2.default, {
          attachments: _this2.props.attachments,
          channel: _this2.props.channel,
          companyName: _this2.props.companyName,
          consentToCommunicateMessage: _this2.props.consentToCommunicateMessage,
          hasVisitorEmail: _this2.props.hasVisitorEmail,
          key: key,
          message: message,
          nextMessage: nextMessage,
          onAttachmentClick: _this2.props.onAttachmentClick,
          onAttachmentLoad: _this2.props.onAttachmentLoad,
          previousMessage: previousMessage,
          responders: _this2.props.responders,
          potentialResponders: _this2.props.potentialResponders,
          sendFromResponders: _this2.props.sendFromResponders,
          chatHeadingConfig: _this2.props.chatHeadingConfig,
          currentRole: _this2.props.currentRole,
          coloring: _this2.props.coloring,
          publishMessage: _this2.props.publishMessage,
          republishMessage: _this2.props.republishMessage,
          requiresConsentToCommunicate: _this2.props.requiresConsentToCommunicate,
          requiresExplicitConsentToProcess: _this2.props.requiresExplicitConsentToProcess,
          sendVisitorEmailAddress: _this2.props.sendVisitorEmailAddress,
          systemOnline: _this2.props.systemOnline,
          currentVisitor: _this2.props.currentVisitor,
          typingResponder: _this2.props.typingResponder
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'p-top-1' },
        this.renderHistory()
      );
    }
  }]);

  return VisitorThreadHistory;
}(_react2.default.PureComponent);

VisitorThreadHistory.propTypes = propTypes;
VisitorThreadHistory.defaultProps = defaultProps;

exports.default = VisitorThreadHistory;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-conversations/static-1.5219/js/visitor-thread-history/components/VisitorThreadHistory.js
// module id = 1083
// module chunks = 2 3